import { Injectable } from '@angular/core';
import {
    Request,
    XHRBackend,
    RequestOptions,
    Response,
    Http,
    RequestOptionsArgs,
    Headers
} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router, RouterStateSnapshot } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Helpers } from '../helpers';
import { DataService } from './data.service';

@Injectable()
export class ExtendedHttpService extends Http {
    state: RouterStateSnapshot;
    constructor(
        backend: XHRBackend,
        defaultOptions: RequestOptions,
        private router: Router,
        private dataService: DataService
    ) {
        super(backend, defaultOptions);
    }

    request(
        url: string | Request,
        options?: RequestOptionsArgs
    ): Observable<Response> {
        //do whatever
        if (typeof url === 'string') {
            this.setHeaders(options);
        } else {
            this.setHeaders(url);
        }
        var urlString = url['url'];
        if (!urlString.startsWith('http://') || !urlString.startsWith('//')) {
            var apiEndpoint = Helpers.getApiEndpoint();
            url['url'] = apiEndpoint + urlString;
        }
        return super.request(url, options).catch(this.catchErrors());
    }

    private catchErrors() {
        return (res: Response) => {
            if (res.status === 401) {
                localStorage.clear();
                this.dataService.removeAuthData();
                this.router.navigate([this.dataService.path + '/login']);
            } else if (res.status === 403) {
                this.router.navigate([this.dataService.path + '/forbidden-error']);
            }
            return Observable.throw(res);
        };
    }

    private setHeaders(objectToSetHeadersTo: Request | RequestOptionsArgs) {
        if (!objectToSetHeadersTo) {
            objectToSetHeadersTo = { headers: new Headers() };
        }
        if (objectToSetHeadersTo.headers.keys().length < 1) {
            objectToSetHeadersTo.headers.set('Content-Type', 'application/json');
            objectToSetHeadersTo.headers.set(
                'Accept',
                'q=0.8;application/json;q=0.9'
            );
        }
        var token = Helpers.getAccessToken();
        if (token)
            objectToSetHeadersTo.headers.set('Authorization', 'Bearer ' + token);
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/_services/extended-http.service.ts